import * as actionTypes from '../actions/actionTypes';
import * as actions from './index';
import { verifyUserInputs } from 'helpers/UserHelper';

export const updateProfileObjectsSuccess = (data) => {
    return {
        type: actionTypes.PROFILE_UPDATE_PROFILEOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateProfileObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateProfileObjectsSuccess(obj));
    }
}

export const setProfileInitialState = (data) => {
    return {
        type: actionTypes.PROFILE_SET_INITIAL_STATE,
        payload: data
    }
}

export const updateUserProfile = (userInputs) => {
    console.log("LOGS: LAMTEST01 updateUserProfile userInputs", userInputs);
    let uInputs = verifyUserInputs({ userInputs });
    return async (dispatch) => {
        dispatch(actions.updateProfileObjects({ loading: true, status: 'saving', msg: 'Es wird bearbeitet...' }));
        setTimeout(async () => {
            try {
                const res = await window.flow.sdkFeReEditUser({ ...uInputs });
                console.log("LOGS: LAMTEST01 updateUserProfile res", res);
                let user;
                if (res && res.data && res.data.user) user = res.data.user;
                else if (res.msg && res.msg.user) user = res.msg.user;
                if (user) {
                    user = { metadata: { fields: { ...user } } };
                    localStorage.setItem("user", JSON.stringify(user));
                    dispatch(actions.updateAuthObjects({
                        loading: false, isLoggedIn: true, user, loginErr: false
                    }));
                    dispatch(actions.updateProfileObjects({ loading: false, status: { success: res.success, msg: res.msg } }));
                } else {
                    dispatch(actions.updateProfileObjects({ loading: false, status: { error: true, msg: res.msg } }));
                }

            } catch (err) {
                dispatch(actions.updateProfileObjects({ loading: false }));
            }
        }, 1000);
    }
}